import { useEffect, useState } from "react";
import { FiArrowRight, FiInfo, FiShoppingBag } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../components/Button";
import Input from "../components/Input";
import Modal from "../components/Modal";
import ProductCard from "../components/ProductCard";
import {
  createDataFunc,
  filterCategoryFunc,
  searchDataFunc,
  updateDataFunc,
} from "../redux/dataSlice";
import { modalFunc } from "../redux/modalSlice";

const Product = () => {
  const { modal } = useSelector((state) => state.modal);
  const { data, keyword, categoryFilter } = useSelector((state) => state.data);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [productInfo, setProductInfo] = useState({
    name: "",
    price: "",
    url: "",
    category: "Elektronik",
    stock: "",
    description: "",
    rating: "4.0",
  });

  const onChangeFunc = (e, type) => {
    if (type === "url") {
      setProductInfo((prev) => ({
        ...prev,
        [e.target.name]: URL.createObjectURL(e.target.files[0]),
      }));
    } else {
      setProductInfo((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    }
  };

  let loc = location?.search.split("=")[1];

  useEffect(() => {
    if (loc) {
      const foundProduct = data.find((dt) => dt.id.toString() === loc);
      if (foundProduct) {
        setProductInfo(foundProduct);
      }
    } else {
      setProductInfo({
        name: "",
        price: "",
        url: "",
        category: "Elektronik",
        stock: "",
        description: "",
        rating: "4.0",
      });
    }
  }, [loc, data]);

  const buttonFunc = () => {
    const newId =
      data.length > 0
        ? (Math.max(...data.map((d) => parseInt(d.id))) + 1).toString()
        : "1";
    dispatch(createDataFunc({ ...productInfo, id: newId }));
    dispatch(modalFunc());
  };

  const buttonUpdateFunc = () => {
    dispatch(updateDataFunc({ ...productInfo, id: loc }));
    dispatch(modalFunc());
    navigate("/");
  };

  const contentModal = (
    <div className="flex flex-col gap-5">
      <Input
        value={productInfo.name}
        type={"text"}
        placeholder={"Product Title"}
        name={"name"}
        id={"name"}
        onChange={(e) => onChangeFunc(e, "name")}
      />
      <div className="grid grid-cols-2 gap-4">
        <Input
          value={productInfo.price}
          type={"number"}
          placeholder={"List Price ($)"}
          name={"price"}
          id={"price"}
          onChange={(e) => onChangeFunc(e, "price")}
        />
        <Input
          value={productInfo.stock}
          type={"number"}
          placeholder={"Available Stock"}
          name={"stock"}
          id={"stock"}
          onChange={(e) => onChangeFunc(e, "stock")}
        />
      </div>
      <div className="flex flex-col gap-2 w-full">
        <label className="text-xs font-bold text-gray-500 uppercase tracking-widest ml-1">
          Category
        </label>
        <select
          name="category"
          value={productInfo.category}
          onChange={(e) => onChangeFunc(e, "category")}
          className="input-field appearance-none cursor-pointer"
        >
          <option value="Elektronik">Electronics</option>
          <option value="Aksesuar">Accessories</option>
          <option value="Mobilya">Furniture</option>
          <option value="Giyim">Apparel</option>
          <option value="Diğer">Other</option>
        </select>
      </div>
      <div className="flex flex-col gap-2 w-full">
        <label className="text-xs font-bold text-gray-500 uppercase tracking-widest ml-1">
          Product Description
        </label>
        <textarea
          name="description"
          value={productInfo.description}
          onChange={(e) => onChangeFunc(e, "description")}
          placeholder="Brief details about the item..."
          className="input-field min-h-[100px] resize-none"
        ></textarea>
      </div>
      <div className="flex flex-col gap-2 w-full">
        <label className="text-xs font-bold text-gray-500 uppercase tracking-widest ml-1">
          Display Image
        </label>
        <Input
          type={"file"}
          placeholder={"Select Image"}
          name={"url"}
          id={"url"}
          onChange={(e) => onChangeFunc(e, "url")}
        />
      </div>
      <Button
        btnText={loc ? "Save Changes" : "List Product"}
        onClick={loc ? buttonUpdateFunc : buttonFunc}
      />
    </div>
  );

  const filteredItems = data.filter((dt) => {
    const matchesKeyword = dt.name
      .toLowerCase()
      .includes(keyword.toLowerCase());
    const matchesCategory =
      categoryFilter === "All" || dt.category === categoryFilter;
    return matchesKeyword && matchesCategory;
  });

  return (
    <main className="container mx-auto px-10 py-16">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
        <div className="space-y-1">
          <div className="flex items-center gap-2 text-[#893168] font-bold text-sm uppercase tracking-[0.2em]">
            <span className="w-8 h-[2px] bg-[#893168]"></span>
            Curated Collection
          </div>
          <h2 className="text-4xl font-black text-white tracking-tighter">
            Product Catalog
          </h2>
          <p className="text-gray-500 text-sm font-medium">
            Displaying {filteredItems.length} premium items in{" "}
            {categoryFilter === "All" ? "all categories" : categoryFilter}.
          </p>
        </div>

        <div className="flex items-center gap-3 bg-[#2e1c2b] border border-[#893168]/10 px-6 py-3 rounded-md text-gray-400 text-xs font-semibold">
          <FiInfo size={16} className="text-[#893168]" />
          Synchronized with local storage database.
        </div>
      </div>

      {filteredItems.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10">
          {filteredItems.map((dt, i) => (
            <ProductCard key={dt.id || i} dt={dt} />
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center py-40 border-2 border-dashed border-white/5 rounded-2xl">
          <div className="w-24 h-24 bg-[#2e1c2b] rounded-full flex items-center justify-center mb-8">
            <FiShoppingBag size={40} className="text-gray-600" />
          </div>
          <h2 className="text-2xl font-bold text-gray-300">No items found</h2>
          <p className="text-gray-500 mt-2 max-w-sm text-center font-medium">
            We couldn't find any products matching your current search or
            category filters.
          </p>
          <button
            onClick={() => {
              dispatch(searchDataFunc(""));
              dispatch(filterCategoryFunc("All"));
            }}
            className="mt-8 flex items-center gap-2 text-[#893168] hover:text-white font-bold transition-all group"
          >
            Clear Search Filters{" "}
            <FiArrowRight className="group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      )}

      {modal && (
        <Modal
          content={contentModal}
          title={loc ? "Edit Product" : "Launch New Product"}
        />
      )}
    </main>
  );
};

export default Product;
